import PageTypeConfig from "./PageTypeConfig";

export default new class PageTypeResolveService {
    private readonly pageConfig: PageTypeConfig | undefined = undefined;

    constructor() {
        const scriptElementContent = document.querySelector<HTMLScriptElement>("#js-page-config")?.textContent;

        if (scriptElementContent === undefined) {
            return;
        }

        this.pageConfig = JSON.parse(scriptElementContent) as PageTypeConfig;
    }

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
    public getConfig<T extends PageTypeConfig>(): T {
        if (this.pageConfig === undefined) {
            throw new Error("Page config not found for this page.");
        }

        return this.pageConfig as unknown as T;
    }

    public isHomePage(): boolean {
        return this.pageConfig?.type === "homepage";
    }

    public isProductList(): boolean {
        return this.pageConfig?.type === "list";
    }

    public isProductDetail(): boolean {
        return this.pageConfig?.type === "detail";
    }

    public isBasketPage(): boolean {
        return this.pageConfig?.type === "basket";
    }

    public isCheckoutPage(): boolean {
        return this.pageConfig?.type === "checkout";
    }

    public isLoginPage(): boolean {
        return this.pageConfig?.type === "login";
    }

    public isRegistrationPage(): boolean {
        return this.pageConfig?.type === "registration";
    }

    public isPackageBlockbuster(): boolean {
        return this.pageConfig?.type === "blockbuster";
    }

    public isCustomerProfile(): boolean {
        return this.pageConfig?.type === "customer-profile";
    }

    public isOrderFinished(): boolean {
        return this.pageConfig?.type === "order-finished";
    }

    public isStoresPage(): boolean {
        return this.pageConfig?.type === "stores-page";
    }

    public isAmioChatPage(): boolean {
        return this.pageConfig?.type === "amio-chat-page";
    }

    public isSharedBasketPage(): boolean {
        return this.pageConfig?.type === "shared-basket-page";
    }

    public isTextPage(): boolean {
        return this.pageConfig?.type === "text-page";
    }

    public isSerpPage(): boolean {
        return this.pageConfig?.type === "serp-page";
    }
}();
